import PropTypes from 'prop-types'
import React from 'react'

import { FormSectionCollapsible } from 'twyne-new.ui'

import SankeyD3 from './SankeyD3'
import { numberFormat, formatPath } from './formatters'

const propTypes = {
  item: PropTypes.object,
  progressionType: PropTypes.string,
  isShow: PropTypes.bool,
  onShow: PropTypes.func,
}

const CardTitle = ({ item }) => <div className='flex items-center'>
  <span className='text-md truncate w-[70%]'>{formatPath(item)}</span>
  <span className='mx-1'>-</span>
  <span className='text-sm twy-text-base'>{numberFormat(item.total)} total impressions</span>
</div>

const Header = ({ item }) => <div className='w-full flex justify-between items-center'>
  <CardTitle item={item} />
</div>

const PathFinderBody = ({ item }) => <>
  <FormSectionCollapsible
    collapsible={false}
    defaultOpen
    border
    triggerClass='py-2 px-4 twy-subtle-neutral'
    contentClass='p-4 overflow-visible'
    titleClass='text-base pr-2'
    sectionClass='w-full overflow-visible'
    title={<Header item={item} />}
  >
    <div className='w-full h-[670px]' id={`sankey-${item.value}`}>
      <SankeyD3
        data={item.sankey}
        containerId={`sankey-${item.value}`} />
    </div>
  </FormSectionCollapsible>
</>

PathFinderBody.propTypes = propTypes

export default PathFinderBody
